/** 资源库三语文案分片 · 数字人/语音（由 strings.ts 聚合） */
export const resPartDh = {
  // PresetVoiceFormDialog：系统预设音色上传/编辑弹窗
  resDhEditPresetVoiceTitle: { en: "Edit system preset voice", zh: "编辑系统预设音色", id: "Edit suara preset sistem" },
  resDhPresetVoiceAdminHint: {
    en: "Maintained by platform admins only, visible to all users",
    zh: "仅平台管理员可维护，所有用户可见",
    id: "Hanya dikelola admin platform, terlihat oleh semua pengguna",
  },
  resDhAudioFileLabel: { en: "Audio file", zh: "音频文件", id: "File audio" },
  resDhAudioFormatHint: { en: "Supports mp3 / wav / m4a, duration 2s ~ 120s", zh: "支持 mp3 / wav / m4a，时长 2s ~ 120s", id: "Mendukung mp3 / wav / m4a, durasi 2 dtk ~ 120 dtk" },
  resDhAgeLabel: { en: "Age", zh: "年龄", id: "Usia" },
  resDhAgeYouth: { en: "Young adult", zh: "青年", id: "Dewasa muda" },
  resDhAgeMiddle: { en: "Middle-aged", zh: "中年", id: "Paruh baya" },
  resDhScenarioLabel: { en: "Use scenario", zh: "应用场景", id: "Skenario penggunaan" },
  resDhScenarioPh: { en: "e.g. general scenarios", zh: "如：通用场景", id: "mis. skenario umum" },
  resDhRolePlayLabel: { en: "Role play", zh: "角色演绎", id: "Penghayatan peran" },
  resDhOptionalPh: { en: "Optional", zh: "可选", id: "Opsional" },
  resDhDialectLabel: { en: "Dialect", zh: "方言", id: "Dialek" },
  resDhSaveChanges: { en: "Save changes", zh: "保存修改", id: "Simpan perubahan" },
  resDhAudioExtUnsupported: {
    en: "Only common audio formats such as mp3 / wav / m4a are supported",
    zh: "仅支持 mp3 / wav / m4a 等常见音频格式",
    id: "Hanya mendukung format audio umum seperti mp3 / wav / m4a",
  },
  resDhKeepAudioHint: { en: "Keep current audio (click to replace)", zh: "保留当前音频（点击可替换）", id: "Pertahankan audio saat ini (klik untuk mengganti)" },
  resDhPickAudioHint: { en: "Click to choose an audio file", zh: "点击选择音频文件", id: "Klik untuk memilih file audio" },
  resDhVoiceDetailLoadFail: {
    en: "Failed to load voice details. You can still edit the basic info.",
    zh: "加载音色详情失败，可继续编辑基础信息",
    id: "Gagal memuat detail suara, Anda tetap dapat mengedit info dasar",
  },
  resDhAudioFileRequired: { en: "Please choose an audio file", zh: "请选择音频文件", id: "Mohon pilih file audio" },
  resDhAudioUploadFailed: { en: "Audio upload failed", zh: "音频上传失败", id: "Gagal mengunggah audio" },
  resDhSubmitFail: { en: "Submit failed", zh: "提交失败", id: "Gagal mengirim" },
  // DigitalHumanDeriveBaseDrawer：衍生基底选择
  resDhDeriveBaseNotReady: {
    en: "This character has not finished generating and cannot be used as a base",
    zh: "该数字人尚未生成完成，无法作为基底",
    id: "Karakter ini belum selesai dibuat dan tidak dapat dijadikan dasar",
  },
} as const;
